import axios from "axios";
import {inject, provide, reactive, toRefs} from "@vue/composition-api";


export const state = reactive({
    allEmailSignatures: []
});

export const actions = {
    saveEmailSignature: async (signature) => {
        const signatureId = signature.id || ''
        return await axios.post(`email_signature/${signatureId}`, {...signature})
    },
    fetchAllEmailSignatures: async (companyId) => {
        let emailSignatures = []
        try {
            const response = await axios.get(`email_signature/all?company_id=${companyId}`)
            emailSignatures = response.data?.email_signatures
            state.allEmailSignatures = emailSignatures
        } catch (error) {
            console.error(error)
        }
        state.allEmailSignatures = emailSignatures
    },
    fetchEmailSignature: async (signatureId, companyId) => {
        const response = await axios.get(`email_signature/${signatureId}?company_id=${companyId}`)
        return response.data
    },
    deleteSignature: async (signatureId, companyId) => {
        const response = await axios.delete(`email_signature/${signatureId}`, {params: {company_id: companyId}})
        if (!response.data?.errors) {
            state.allEmailSignatures = state.allEmailSignatures.filter(s => s.id !== signatureId)
        }

        return response

    },
    sendTestEmail: async (signature) => {
        return await axios.post(`email_signature/send_test_email`, {...signature})
    }
};

export const getter = {
    getMemberDefaultSignature: (placeholders) => {
        const signatures = placeholders.find(p => p.type === 'signature')?.value
        if (!signatures) {
            return null
        }
        return signatures.find(s => s.is_for_everyone === 0 && s.is_default === 1)
    }
}

export const key = Symbol("EmailSignatureModule");

export const provideEmailSignature = () =>
    provide(key, {
        ...toRefs(state),
        ...actions,
        ...getter
    });

export default () => inject(key);
